var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.027 12.5002L44.0121 22.4853L34.034 32.4635L33.4856 33.0118C31.0768 35.4207 27.848 37.0045 24.2585 37.3074L24.2585 37.3074L24.2521 37.308C23.8218 37.3471 23.4029 37.3665 22.9743 37.3665C21.2692 37.3663 19.647 37.0822 18.129 36.5501L18.129 36.5501L18.1225 36.5479C12.2833 34.5455 8.08556 29.0044 8.08991 22.4828V22.4821C8.08938 15.9655 12.2811 10.4294 18.1214 8.41781L18.1264 8.41604C19.6419 7.885 21.2696 7.6054 22.9731 7.6005C23.4022 7.60058 23.8304 7.62016 24.2473 7.65898L24.2473 7.65903L24.2572 7.65985C27.8512 7.95842 31.079 9.54246 33.4823 11.9555L33.4838 11.9569L34.0218 12.495L34.027 12.5002Z",
    stroke: "#4D525B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendComment);
export default __webpack_public_path__ + "static/media/send_comment.996354995113355ddc19fced61342c8d.svg";
export { ForwardRef as ReactComponent };